import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
import PwcPhone from '@/components/PwcPhone/desktop'
import PwcPhoneVerify from '@/components/PwcPhoneVerify/desktop'
import { upload } from '@/mixin/file'
// import RouterName from '@/constants/route'
import { http } from '@/api'
import { PublicEvent, Apply } from '@/api/collection'
import { formatDate } from '@/util/date'
import { sortBy } from '@/util'
import { setCookSurveySubmit, getSurveySubmit } from '@/util/auth'
import { setLocal, getLocal } from '@/util/local'
import { Notify } from 'vant'
import { loading } from '@/mixin'
import { _trackEvent } from '@/util'
import { addZero } from '@/util'
import { wechat, checkAuth } from '@/mixin/index'
import res from './res.js'

const formatType = {
  'date': 'yyyy-MM-dd',
  'datetime': 'yyyy-MM-dd hh:mm:ss',
  'year-month': 'yyyy-MM'
}
export const common = {
  components: {
    PwcPhone,
    PwcPhoneVerify
  },
  data() {
    return {
      noShowPublicQR: false,
      data: {
        'Questions': [],
        'Thanks': [],
        'Title': '',
        'InternalTitle': '',
        'Description': '',
        'Image': '',
        'needFetchAnswer': false,
        'noLoginSubmit': false,
        'needReassignAcAic': false
      },
      surveyKey: '',
      SurveyType: 'NA',
      showVerifyDialog: false,
      verification: {
        phoneNo: '',
        contryCode: 86,
        needSendtoMail: true,
        email: '',
        verificationCode: ''
      },
      fileKeys: [],
      formData: {},
      answers: null,
      leadBaseInfoLastAnswer: {},
      needLogin: false,
      noLogin: false,
      code: '',
      id: '',
      referLeadId: '',
      params: [],
      surveySubmitInfo: {},
      successAttachment: [],
      showCaptchaDialog: false,
      captchaObj: {
        image: '',
        answer: '',
        captcha: ''
      },
      submitLoading: false,
      submited: false,
      showAdvancedThanksPage: false,
      productId: '',
      endTime: '',
      intakeLookups: [],
      mapKeys: {
        '1619090528000_66044': 'name_ZH',
        '1619090548000_31013': 'name_EN',
        '1619090832000_49447': 'mobile',
        '1619332110000_73390': 'identityType',
        '1619332110000_73390Other': 'identityType',
        '1619090708000_20835': 'identityNo',
        '1619336880000_80344': 'gender',
        '1619090775000_55608': 'birthDateYM',
        '1619340653000_95631': 'newschool',
        '1619090812000_61900': 'major',
        '1619318142000_8195': 'grade',
        '1619149843000_46991': 'selIntake',
        '1635741017000_55228': 'addr',
        '1619090841000_45711': 'memo'
      }
    }
  },
  mixins: [upload, loading, wechat, checkAuth],
  computed: {
    tempFiles() {
      return this.$store.getters.tempFiles
    },
    cLoading() {
      return this.submitLoading
    },
    ...mapState(['loading', 'userInfo'])
  },
  async created() {
    const route = {}
    Object.keys(this.$route.query).forEach(k => {
      const key = k.toLowerCase()
      route[key] = this.$route.query[k]
    })
    this.code = route['code'] || route['param'] || '' // minisite code
    this.id = route['id'] || ''
    this.referLeadId = route['referid'] || '' // 要用小写
    this.surveyKey = route['surveykey']
    this.productId = route['productid'] || ''
    this.endTime = route['endtime'] || ''
    const params = route['params'] || '' // 默认题目
    console.log('params', params)
    if (params) {
      try {
        const dParam = decodeURI(window.atob(params))
        this.params = dParam.split('|')
        console.log('params', this.params)
      } catch (e) {
        console.log(e)
      }
    }
    await this.GetIntakeLookups()
    if (this.userInfo.token) {
      await this.GetSurveyAnswers()
    }
    this.showAdvancedThanksPage = false
    await this.getNewSurvey({ surveyKey: this.surveyKey })
  },
  methods: {
    ...mapActions({
      getVerifyCode: Actions.GET_VERIFY_CODE,
      loginRequest: Actions.SIMPLE_LOGIN,
      saveNewSurveyAnswer: Actions.SAVE_NEW_SURVEY_ANSWER,
      saveAnonymousSurveyAnswer: Actions.SAVE_ANONYMOUS_SURVEY_ANSWER,
      logout: Actions.LOGOUT
    }),
    async GetSurveyAnswers() {
      const answer = await http({
        path: Apply.GetIntakeInfo.path,
        method: Apply.GetIntakeInfo.method,
        data: { productId: this.productId }
      })
      // if (answer.resultCode === '0' && answer.answers) {
      //   this.answers = answer.answers
      // }
      if (answer.resultCode === '0') {
        this.leadBaseInfoLastAnswer = Object.assign(answer.data)
      }
    },
    async GetIntakeLookups() {
      const res = await http({
        path: Apply.GetIntakeLookups.path,
        method: Apply.GetIntakeLookups.method,
        data: { productId: this.productId, endTime: this.endTime }
      })
      if (res.resultCode === '0') {
        this.intakeLookups = res.data
      }
    },
    async getNewSurvey() {
      const survey = res
      const originalObj = JSON.parse(survey.original || '{}')
      this.noLogin = originalObj.widgetForm.noLoginSubmit
      this.noShowPublicQR = originalObj.widgetForm.noShowPublicQR
      if (this.isWechat) {
        this.checkWechatAuth()
      }
      console.log('No Login:' + this.noLogin)

      const surveyObj = JSON.parse(survey.transfered || '{}')
      surveyObj.Questions && surveyObj.Questions.forEach(item => {
        if (!item.QuestionId.startsWith('Q')) {
          item.QuestionId = this.surveyKey || '' + item.QuestionId
        }
        if (item.options) {
          item.options.forEach(op => {
            if (!op.id.startsWith('Q')) {
              op.id = this.surveyKey || '' + op.id
            }
          })
        }
      })
      this.$set(this, 'data', surveyObj)
      this.needLogin = survey && survey.needFetchAnswer
      if (this.needLogin) {
        this.submited = false
      } else {
        this.surveySubmitInfo = getSurveySubmit() || {}
        this.submited = this.surveySubmitInfo[this.surveyKey]
        if (this.id) {
          this.submited = this.submited && getLocal(this.surveyKey).includes(this.id)
          // if (this.submited) {
          //   this.showThanksPage()
          // }
        } else {
          // if (this.submited) {
          //   this.showThanksPage()
          // }
        }
      }
      this.initFormData()
    },
    initFormData() {
      this.formData = {}
      this.data.Title = this.intakeLookups.title
      this.data.Questions.forEach((item, index) => {
        if (item.key === '1619090382000_3309') {
          item.meta.defaultValue = this.intakeLookups.description
        }
        this.$set(item, 'hidden', false)
        if (this.mapKeys[item.key]) {
          this.$set(item, 'default', this.mapKeys[item.key].toUpperCase())
        }
        if (item.type === 'checkbox' || item.type === 'uploadImgs' || item.type === 'fileupload' || item.type === 'imgupload') {
          this.$set(this.formData, item.key, [])
        } else if (item.type === 'checkboxInput') {
          this.$set(this.formData, item.key, [])
          this.$set(this.formData, item.key + 'Input', {})
        } else if (item.type === 'rate' || item.type === 'number') {
          this.$set(this.formData, item.key, 0)
        } else {
          this.$set(this.formData, item.key, '')
        }
        if (item.type === 'radio' || item.type === 'select' || item.type === 'checkbox' || item.type === 'sorting') {
          item.options.forEach(op => {
            if (op.id.endsWith('Other')) {
              this.$set(this.formData, item.key + 'Other', '')
            }
          })
        }
        if (item.type === 'sorting') {
          item.meta.defaultValue = item.options.map((it, ind) => {
            return addZero(ind) + '#' + it.id
          })
        }
        if (item.meta.defaultValue && !item.meta.justShow) {
          if (item.type === 'select') {
            // eslint-disable-next-line eqeqeq
            const obj = item.options.find(o => o.value == item.meta.defaultValue)
            this.$set(item, 'text', item.meta.defaultValue)
            if (obj) {
              this.$set(this.formData, item.key, obj.id || '')
            }
          } else if (item.type === 'radio') {
            // eslint-disable-next-line eqeqeq
            const obj = item.options.find(o => o.value == item.meta.defaultValue)
            if (obj) {
              this.$set(this.formData, item.key, obj.id || '')
            }
          } else if (item.type === 'checkbox') {
            const ids = []
            item.options.forEach(op => {
              if (item.meta.defaultValue.includes(op.value)) {
                ids.push(op.id)
              }
            })
            this.$set(this.formData, item.key, ids)
          } else {
            this.$set(this.formData, item.key, item.meta.defaultValue)
          }
        }
        if ((this.userInfo.phoneNo || this.userInfo.phone) && (item.default === 'PHONE' || item.default === 'MOBILE')) {
          this.$set(this.formData, item.key, (this.userInfo.phoneNo || this.userInfo.phone))
          item.meta.countryCode = this.userInfo.countryCode
          item.meta.disabled = true
        }

        if (Object.keys(this.leadBaseInfoLastAnswer).length > 0) {
          // this.submited = Boolean(this.leadBaseInfoLastAnswer.selIntake)
          if (item.default === 'CLAUSE') {
            this.$set(this.formData, item.key, ['PCLAUSEo76128'])
          }
          if (item.default === 'GRADE') {
            item.options = []
            this.intakeLookups.grades.forEach(it => {
              item.options.push({
                id: it.id,
                label: it.name,
                value: it.name,
                next: ''
              })
            })
          }
          if (item.default === 'SELINTAKE') {
            item.options = []
            this.intakeLookups.intakes.forEach(it => {
              item.options.push({
                id: it.id,
                label: it.name,
                value: it.name,
                next: ''
              })
            })
          }
          if (item.key === 'WECHAT') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['birthDateYM'] || '')
          }
          if (item.default === 'TITLE') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['title'] || '')
          }
          if (item.default === 'NEWSCHOOL') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['school'] || '')
          }
          if (item.default === 'NAME') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['name'] || '')
          }
          if (item.default === 'name_ZH'.toUpperCase()) {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['name_ZH'] || '')
          }
          if (item.default === 'NAME_EN') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['name_EN'] || '')
          }
          if (item.default === 'birthDateYM'.toUpperCase()) {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['birthDateYM'] || '')
          }
          if (item.default === 'addr'.toUpperCase()) {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['addr'] || '')
          }
          if (item.default === 'memo'.toUpperCase()) {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['memo'] || '')
          }
          if (item.default === 'identityNo'.toUpperCase()) {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['identityNo'] || '')
          }
          if (item.default === 'MAJOR') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['major'] || '')
          }
          if (item.default === 'INDUSTRY') {
            if (this.leadBaseInfoLastAnswer['industry'].length > 0) {
              const obj = item.options.find(it => it.value.indexOf(this.leadBaseInfoLastAnswer['industry']) > -1)
              this.$set(this.formData, item.key, obj && obj.id)
            }
          }
          if (item.default === 'selIntake'.toUpperCase()) {
            if (this.leadBaseInfoLastAnswer['selIntake'].length > 0) {
              const obj = item.options.find(it => it.id.indexOf(this.leadBaseInfoLastAnswer['selIntake']) > -1)
              this.$set(this.formData, item.key, obj && obj.id)
            }
          }
          if (item.default === 'GRADE') {
            if (this.leadBaseInfoLastAnswer['grade']) {
              const obj = item.options.find(it => it.id.indexOf(this.leadBaseInfoLastAnswer['grade']) > -1)
              if (obj) {
                this.$set(this.formData, item.key, obj && obj.id)
                this.$set(item, 'text', obj.value)
              }
            }
          }
          if (item.default === 'AGE') {
            if (this.leadBaseInfoLastAnswer['ageRange']) {
              const obj = item.options.find(it => it.value.indexOf(this.leadBaseInfoLastAnswer['ageRange']) > -1)
              this.$set(this.formData, item.key, obj && obj.id)
            }
          }
          if (item.default === 'GENDER') {
            if (this.leadBaseInfoLastAnswer['gender'] !== undefined) {
              const obj = item.options.find(it => it.id.indexOf(this.leadBaseInfoLastAnswer['gender']) > -1)
              this.$set(this.formData, item.key, obj && obj.id)
            }
          }
          if (item.default === 'EMAIL') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['email'] || '')
          }
          if (item.default === 'COMPANY') {
            this.$set(this.formData, item.key, this.leadBaseInfoLastAnswer['company'] || '')
          }
          if (item.default === 'WKAGE') {
            if (this.leadBaseInfoLastAnswer['yearsOfWork']) {
              const obj = item.options.find(it => it.value.indexOf(this.leadBaseInfoLastAnswer['yearsOfWork']) > -1)
              this.$set(this.formData, item.key, obj && obj.defaultId)
            }
          }
          if (item.default === 'EDUORWORK') {
            const obj = item.options.find(it => Number(it.defaultId) === this.leadBaseInfoLastAnswer['educationOrWork'] || '')
            this.$set(this.formData, item.key, obj && obj.defaultId)
          }
          if (item.default === 'identityType'.toUpperCase()) {
            if (this.leadBaseInfoLastAnswer['identityType'] === null || this.leadBaseInfoLastAnswer['identityType'] === '身份证') {
              this.$set(this.formData, item.key, 'P1619332110000_73390o76586')
            } else {
              this.$set(this.formData, item.key, 'P1619332110000_73390o47962Other')
              this.$set(this.formData, item.key + 'Other', this.leadBaseInfoLastAnswer['identityType'])
            }
          }
        }

        // 如果要有答案, 这里获取答案并覆盖
        if (this.answers) {
          this.answers.forEach(q => {
            if (q.questionId === item.QuestionId) {
              if (item.type === 'checkbox') {
                const answers = q.answerContent.split(',')
                this.$set(this.formData, item.key, answers)
                const other = answers.find(it => it.endsWith('Other'))
                if (other) {
                  const ids = item.options.map(it => it.id)
                  for (let i = 0; i < answers.length; i++) {
                    if (!ids.includes(answers[i])) {
                      this.$set(this.formData, item.key + 'Other', answers[i])
                      this.formData[item.key].splice(i, 1)
                      return
                    }
                  }
                }
              } else if (item.type === 'checkboxInput') {
                const answers = q.answerContent.split(',')
                const answerOption = []
                const answersInput = {}
                answers.forEach(item => {
                  if (item.indexOf('|*|')) {
                    const arr = item.split('|*|')
                    answerOption.push(arr[0])
                    answersInput[arr[0]] = arr[1] || ''
                  }
                })

                this.$set(this.formData, item.key, answerOption)
                this.$set(this.formData, item.key + 'Input', answersInput)
              } else if (item.type === 'sorting') {
                const sortans = q.answerContent.split(',')
                this.$set(this.formData, item.key, [])
                sortans.forEach(it => {
                  if (it) {
                    if (it.includes(`#${q.questionId}`)) {
                      const ans = it.split('#')
                      item.options.forEach(op => {
                        if (op.id === ans[1]) {
                          op.order = Number(ans[0])
                        }
                      })
                      this.formData[item.key].push(it)
                    } else {
                      this.$set(this.formData, item.key + 'Other', it)
                    }
                  }
                })
                this.$set(item, 'options', item.options.sort(sortBy('order')))
                // this.$set(this.formData, item.key, sortans)
              } else if (item.type === 'rate') {
                this.$set(this.formData, item.key, Number(q.answerContent))
              } else if (item.type === 'uploadImgs') {
                this.$set(this.formData, item.key, q.answerContent && q.answerContent.split(','))
              } else if (item.type === 'fileupload' || item.type === 'imgupload') {
                this.$set(this.formData, item.key, q.answerContent && q.answerContent.split(','))
              } else if (item.type === 'select' || item.type === 'radio') {
                if (q.answerContent) {
                  const obj = item.options.find(o => o.defaultId || o.id === q.answerContent)
                  if (obj) {
                    this.$set(item, 'text', obj.value || '')
                    this.$set(this.formData, item.key, q.answerContent)
                  } else {
                    const other = item.options.find(o => o.id.endsWith('Other'))
                    if (other && !q.answerContent.includes(q.questionId)) {
                      this.$set(item, 'text', other.value || '')
                      this.$set(this.formData, item.key, other.id)
                      this.$set(this.formData, item.key + 'Other', q.answerContent)
                    }
                  }
                }
              } else if (item.meta.dataType === 'phone') {
                if (q.answerContent.includes(')')) {
                  const subIndex = q.answerContent.indexOf(')')
                  item.meta.countryCode = Number(q.answerContent.substr(1, subIndex - 1))
                  this.$set(this.formData, item.key, q.answerContent.substr(subIndex + 1))
                } else {
                  this.$set(this.formData, item.key, q.answerContent)
                }
              } else {
                this.$set(this.formData, item.key, q.answerContent)
              }
            }
          })
        } else {
          // 没有答案的时候, 特殊处理报名付款survey key = ''
          if (item.default === 'EVIDENCE') { // 凭据没答案时候不显示
            this.$set(item, 'hidden', true)
          }
        }
        if (this.params.length > 0 && this.params[index]) {
          // 处理参数
          item.meta.disabled = true
          if (item.type === 'date') {
            this.formData[item.key] = formatDate(this.params[index], item.meta.format || 'yyyy-MM-dd')
          } else if (item.type === 'radio' || item.type === 'select') {
            const obj = item.options.find(o => o.value === this.params[index])
            if (obj) {
              this.$set(item, 'text', this.params[index] || '')
              this.$set(this.formData, item.key, obj.defaultId || obj.id)
            } else {
              item.meta.disabled = false
            }
          } else if (item.type === 'checkbox') {
            this.formData[item.key] = [this.params[index]]
          } else {
            this.formData[item.key] = this.params[index]
          }
        }
        if (item.meta.currentDate) {
          this.formData[item.key] = formatDate(new Date(), item.meta.format || 'yyyy-MM-dd')
        }
        if (item.type === 'date' && this.formData[item.key]) {
          this.formData[item.key] = formatDate(
            this.formData[item.key],
            formatType[item.meta.type]
          )
        }
      })
      this.$nextTick(() => {
        this.$refs['dyform'] && this.$refs['dyform'].initNextShow()
        this.$refs['dyform'] && this.$refs['dyform'].resetValidate()
      })
      this.fileKeys = this.data.Questions.map(item => {
        if (item.type === 'imgupload' || item.type === 'fileupload') {
          return item.key
        }
      }).filter(item => item)
    },
    handleVerifyDialogCancel() {
      this.showVerifyDialog = false
    },
    async handleVerifyDialogConfirm() {
      this.submitLoading = true
      this.$store.commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: true })
      // 获取token
      await this.loginRequest({
        contryCode: this.verification.contryCode,
        phoneNo: this.verification.phoneNo,
        verificationCode: this.verification.verificationCode
      })
      // const openid = localStorage.getItem('openId')
      // if (openid) {
      //   await http(
      //     {
      //       path: Wechat.GetWxUserForLead.path,
      //       method: Wechat.GetWxUserForLead.method,
      //       data: {
      //         openid,
      //         leadid: res.leadId,
      //         mobile: this.verification.phoneNo
      //       }
      //     }
      //   )
      // }

      this.showVerifyDialog = false
      const files = Object.values(this.tempFiles).filter(item => item)
      if (files.length > 0) {
        this.uploadAllFiles(files, 1)
      } else {
        this.transAnswer(this.formData)
      }
    },
    async uploadAllFiles(files, where) {
      // 批量上传
      const result = await this.handleSelect(files)
      if (!this.noLogin && result && where === 1) {
        await this.transAnswer(this.formData)
      }
    },
    async handleSelect(files) {
      // 判断大小，分别上传
      const res = await this.uploadToSys(files)

      if (res.resultCode === '0') {
        const hasFileKeys = Object.keys(this.tempFiles).map(k => {
          if (this.tempFiles[k]) {
            return k
          }
        })
        for (let i = 0; i < hasFileKeys.length; i++) {
          const key = hasFileKeys[i]
          this.$set(this.formData, key, res.data[i] || '')
        }
        return true
      } else {
        Notify({
          message: '文件上传失败,请尝试使用手机系统浏览器或电脑端提交',
          duration: 3 * 1000
        })
        return false
      }
    },
    handleGetVerifyCode() {
      return this.getVerifyCode({
        contryCode: this.verification.contryCode,
        phoneNo: this.verification.phoneNo,
        email: this.verification.email,
        needSendtoMail: true
      })
    },
    async submitForm(val) {
      const [surveyCode, surveyPhone] = this.getSurveyPhoneInfo(val)
      const { countryCode: userCountryCode, phoneNo: userPhone } = this.userInfo
      if (this.noLogin) {
        // 免登录请求接口
        this.formData = val
        this.backToTop()
        this.showCaptchaDialog = true
        this.GetCaptcha()
      } else {
        if (this.userInfo.token &&
          this.userInfo.leadId &&
          (this.userInfo.phoneNo || this.userInfo.phone) &&
          ((`${surveyCode}:${surveyPhone}` === `${userCountryCode}:${userPhone}`) || (!surveyCode && !surveyPhone))) {
          const files = Object.values(this.tempFiles).filter(item => item)
          if (files.length > 0 && !this.needLogin) {
            await this.uploadAllFiles(files, 2)
          }
          this.transAnswer(val)
        } else {
          this.formData = val
          this.data.Questions.forEach(q => {
            if (q.default === 'PHONE' || q.default === 'MOBILE') {
              this.verification.phoneNo = this.formData[q.key]
              this.verification.contryCode = q.meta.countryCode
            }
            if (q.default === 'EMAIL') {
              this.verification.email = this.formData[q.key] || ''
            }
          })
          this.backToTop()
          this.showVerifyDialog = true
          this.submitLoading = false
        }
      }
    },
    backToTop() {
      window.scroll(0, 0)
    },
    async transAnswer(formData) {
      // 3, 更新文件答案后提交答案数据
      this.$store.commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: true })
      this.submitLoading = true
      const allAnswers = {
        'leadId': this.userInfo.leadId || '',
        'countryCode': this.verification.contryCode,
        'company': '',
        'title': '',
        'industry': '',
        'industryOther': '',
        'school': '',
        'productId': this.productId
      }
      Object.keys(this.mapKeys).forEach(key => {
        allAnswers[this.mapKeys[key]] = this.formData[key]
      })
      // if (this.formData['1619332110000_73390'].endsWith('Other')) {
      //   allAnswers.identityType = this.formData['1619332110000_73390Other']
      // } else {
      //   allAnswers.identityType = '身份证'
      // }
      if (this.formData['1635741017000_55228'])
      {
        allAnswers['addr'] = this.formData['1635741017000_55228']
      }      

      allAnswers['school'] = allAnswers.newschool
      delete allAnswers.newschool
      // this.data.Questions.forEach(q => {
      //   const result = {
      //     question: q.QuestionId,
      //     answer: []
      //   }
      //   console.log(JSON.stringify(q.key + ', ' + q.QuestionId))
      //   if (formData[q.key]) {
      //     if (q.type === 'checkbox') {
      //       result.answer = [].concat(formData[q.key])
      //       if (formData[q.key].find(it => { return it.endsWith('Other') }) && formData[q.key + 'Other']) {
      //         result.answer.push(formData[q.key + 'Other'])
      //       }
      //     } else if (q.type === 'sorting') {
      //       result.answer = [].concat(formData[q.key])
      //       if (formData[q.key].find(it => { return it.endsWith('Other') }) && formData[q.key + 'Other']) {
      //         result.answer.push(formData[q.key + 'Other'])
      //       }
      //     } else if (q.type === 'checkboxInput') {
      //       result.answer = []
      //       if (formData[q.key].length > 0) {
      //         formData[q.key].forEach(item => {
      //           const input = formData[q.key + 'Input'][item] || ''
      //           result.answer.push(`${item}|*|${input}`)
      //         })
      //       }
      //     } else if (q.meta.dataType === 'phone') {
      //       result.answer = [`(${q.meta.countryCode})${this.formData[q.key]}`]
      //     } else {
      //       if (Array.isArray(formData[q.key])) {
      //         result.answer = formData[q.key]
      //       } else {
      //         result.answer = [formData[q.key]]
      //       }
      //     }
      //     if (q.type === 'radio' || q.type === 'select') {
      //       if (formData[q.key].endsWith('Other')) {
      //         result.answer = [formData[q.key + 'Other']]
      //       }
      //     }
      //   } else {
      //     result.answer = []
      //   }
      //   if (q.default === 'EVIDENCE' && formData[q.key].length > 0) {
      //     this.showAdvancedThanksPage = true
      //   }
      //   allAnswers.qAs.push(result)
      // })
      // console.log(JSON.stringify(allAnswers))
      const res = await this.saveIntakeInfo(allAnswers)
      if (res.resultCode === '0') {
        // 显示成功页
        this.$store.commit('UPDATE_LOADING', { saveNewSurveyAnswerLoading: false })
        this.submitLoading = false
        // this.showThanksPage(true)
        this.submited = true
        // 提交survey 统计
        // _trackEvent('Submit Survey Answer', '提交', allAnswers.surveyKey, allAnswers.foreignId, 'saveNewSurveyAnswer')
      }
    },
    async saveIntakeInfo(answer) {
      return await http(
        {
          path: Apply.SaveIntakeInfo.path,
          method: Apply.SaveIntakeInfo.method,
          data: answer
        }
      )
    },
    // 获取验证码
    async GetCaptcha() {
      const resData = await http({
        path: PublicEvent.GetCaptcha.path,
        method: PublicEvent.GetCaptcha.method
      })

      if (resData.resultCode === '0') {
        this.captchaObj.image = resData.captcha.image
        this.captchaObj.captcha = resData.captcha.captcha
      }
    },
    // 免登录提交
    async submitAnonymousSurveyAnswer() {
      this.submitLoading = true
      const allAnswers = {
        surveyKey: this.surveyKey,
        campaignSurveyCode: this.code,
        foreignId: this.id || '',
        email: '',
        captchaVerifyDto: {
          answer: this.captchaObj.answer,
          captcha: this.captchaObj.captcha
        },
        qAs: []
      }
      this.data.Questions.forEach(q => {
        const result = {
          question: q.QuestionId,
          answer: []
        }
        if (this.formData[q.key]) {
          if (q.type === 'checkbox') {
            result.answer = [].concat(this.formData[q.key])
            if (this.formData[q.key].find(it => { return it.endsWith('Other') }) && this.formData[q.key + 'Other']) {
              result.answer.push(this.formData[q.key + 'Other'])
            }
          } else if (q.type === 'checkboxInput') {
            result.answer = []
            if (this.formData[q.key].length > 0) {
              this.formData[q.key].forEach(item => {
                const input = this.formData[q.key + 'Input'][item] || ''
                result.answer.push(`${item}|*|${input}`)
              })
            }
          } else if (q.meta.dataType === 'phone') {
            result.answer = [`(${q.meta.countryCode})${this.formData[q.key]}`]
          } else {
            if (Array.isArray(this.formData[q.key])) {
              result.answer = this.formData[q.key]
            } else {
              result.answer = [this.formData[q.key]]
            }
          }
          if (q.type === 'radio' || q.type === 'select') {
            if (this.formData[q.key].endsWith('Other')) {
              result.answer = [this.formData[q.key + 'Other']]
            }
          }
        } else {
          result.answer = []
        }
        if (q.default === 'PHONE') {
          this.verification.phoneNo = this.formData[q.key]
          this.verification.contryCode = q.meta.countryCode
        }
        if (q.default === 'EMAIL') {
          allAnswers.email = this.formData[q.key] || ''
        }
        allAnswers.qAs.push(result)
      })

      const res = await this.saveAnonymousSurveyAnswer(allAnswers)
      if (res.resultCode === '0') {
        this.surveySubmitInfo[this.surveyKey] = true
        setCookSurveySubmit(this.surveySubmitInfo)
        setLocal(this.surveyKey, this.$route.query.id || true)
        this.closeAnonymousSurveyAnswer()
        // 上传文件并更新答案文件
        const files = Object.values(this.tempFiles).filter(item => item)
        if (files.length > 0) {
          await this.uploadAllFiles(files, 2)
          const updateAnswers = {
            surveyKey: this.surveyKey,
            campaignSurveyCode: this.code,
            foreignId: this.id || '',
            leadId: this.userInfo.leadId,
            email: '',
            qAs: []
          }
          this.data.Questions.forEach(q => {
            const result = {
              question: q.QuestionId,
              answer: []
            }
            if (this.formData[q.key]) {
              if (q.type === 'checkbox') {
                result.answer = this.formData[q.key]
              } else if (q.meta.dataType === 'phone') {
                result.answer = [`(${q.meta.countryCode})${this.formData[q.key]}`]
              } else {
                if (Array.isArray(this.formData[q.key])) {
                  result.answer = this.formData[q.key]
                } else {
                  result.answer = [this.formData[q.key]]
                }
              }
              if (q.type === 'radio' || q.type === 'select') {
                if (this.formData[q.key].endsWith('Other')) {
                  result.answer = [this.formData[q.key + 'Other']]
                }
              }
            } else {
              result.answer = []
            }
            if (q.default === 'PHONE') {
              this.verification.phoneNo = this.formData[q.key]
              this.verification.contryCode = q.meta.countryCode
            }
            if (q.default === 'EMAIL') {
              updateAnswers.email = this.formData[q.key] || ''
            }
            updateAnswers.qAs.push(result)
          })
          const rr = await this.saveAnonymousSurveyAnswer(updateAnswers)
          if (rr.resultCode === '0') {
            _trackEvent('Submit Survey Answer', '提交', updateAnswers.surveyKey, updateAnswers.foreignId, 'saveAnonymousSurveyAnswer')
          }
        }
        // 显示成功页
        this.submitLoading = false
        this.submited = true
        // this.showThanksPage(true)
        _trackEvent('Submit Survey Answer', '提交', allAnswers.surveyKey, allAnswers.foreignId, 'saveAnonymousSurveyAnswer')
      } else {
        this.captchaObj.image = res.captcha.image
        this.captchaObj.captcha = res.captcha.captcha
        this.captchaObj.answer = ''

        Notify({
          message: res.resultMsg || 'error',
          duration: 3 * 1000
        })
      }
    },
    // 关闭窗口
    closeAnonymousSurveyAnswer() {
      this.captchaObj.image = ''
      this.captchaObj.answer = ''
      this.captchaObj.captcha = ''
      this.showCaptchaDialog = false
    },

    // 显示成功页
    // showThanksPage(openFile) {
    //   // const fileArr = []
    //   this.data.Thanks.forEach(item => {
    //     if (item.type === 'attachment') {
    //       this.successAttachment.push(item.meta.defaultValue)
    //     }
    //   })
    //   if (openFile && this.successAttachment.length === 1) {
    //     window.location.replace(this.successAttachment[0])
    //   }
    // },

    getSurveyPhoneInfo(formData) {
      for (let i = 0; i < this.data.Questions.length; i++) {
        const q = this.data.Questions[i]
        if (formData[q.key]) {
          if (q.meta.dataType === 'phone' || q.default === 'MOBILE') {
            return [q.meta.countryCode, this.formData[q.key]]
          }
        }
      }

      return []
    }
  }
}
